import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/components/Navbar.tsx");
